module.exports = __webpack_public_path__ + "img/icon-ios-action.b7c788f3.svg";